import type { ComponentProps } from 'react';
import { OwcRadioGroup } from '@one/react';

export type PocRadioGroupProps = ComponentProps<typeof OwcRadioGroup>;

export const PocRadioGroup: React.FC<PocRadioGroupProps> = (props) => <OwcRadioGroup {...props} />;
